import { fromDtoToColumnsConfig } from "app/pages/sales-intelligence/modules/leads-search";
import { fromDtoToColumnOptions } from "app/pages/sales-intelligence/modules/leads-search/utils";

import { createAppsColumnCategoriesConfig } from "../configuration/columns/categoryConfig";
import { createAppsSearchColumnListConfig } from "../configuration/columns/columnConfig";
import type { AppsColumnConfigDto, AppsSearchResponseDto } from "../types/dto";
import type { AppColumnCategory, AppSearchRowDto, TableColumnTypeDto } from "../types/rows";
import type { AppsColumnListConfig, AppsColumnSelectionResult, AppsSearchTableData } from "../types/table";

export const createSearchResultsTableDataFromDto = (
    data: AppsSearchResponseDto,
    columnConfig: AppsColumnListConfig = createAppsSearchColumnListConfig(),
): AppsSearchTableData => ({
    ...data,
    columns: fromDtoToColumnsConfig(data.columns, columnConfig),
});

export const createAppsColumnsDataFromDto = (
    data: AppsColumnConfigDto,
    columnConfig: AppsColumnListConfig = createAppsSearchColumnListConfig(),
): AppsColumnSelectionResult => {
    const availableColumns = fromDtoToColumnOptions<AppSearchRowDto, TableColumnTypeDto, AppColumnCategory>(
        data.available,
        columnConfig,
    );

    return {
        selectedColumnIds: data.selected,
        categories: createAppsColumnCategoriesConfig(data.categories),
        availableColumns,
    };
};
